
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
webpack.register(
    'components/social-share/social-share',
    function() {
        return require('components/social-share/social-share');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/image-universal/image-universal'/>\r\n<can-import from='components/social-share/social-share'/>\r\n\r\n<div class=\"c-history-card\">\r\n        <div class=\"s-card\">\r\n            <div class=\"s-card__options\">\r\n            <span class=\"s-strip\"></span>\r\n            </div>\r\n\r\n            <div class=\"s-card__content\">\r\n                <div class=\"s-content\">\r\n                    <div class=\"s-content__right\">\r\n                        <div class=\"s-year\">{{range}}</div>\r\n                        <div class=\"s-title\">{{information}}</div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n</div>");